@if (isVisible) {
  <div class="overlay-container" [class.hide]=!isVisible [@fadeAnimation]="isOverlayVisible()">
    <div class="overlay-container-content has-results m-t-20">
      <div class="container-fluid">
        <a class="close btn btn-info btn-rounded btn-circle  overlay-container-close" href="javascript:void(0)"
          (click)="close($event)">
          <app-icon [name]="'icon-close'" [color]="'white'"></app-icon>
        </a>
        <div class="btn-group close m-r-50 m-t-5">
          @if (manager && value != null && value != '') {
            <button class="btn btn-complete" (click)="showModal()" [disabled]="exportExcelProgress"
              >
              {{'Exportar' | translate}}
            </button>
          }
        </div>
        <input autocomplete="off" #searchField (keyup)="searchKeyPress($event)" (ngModelChange)="changed($event)"
          class="no-border overlay-container-search bg-transparent" [(ngModel)]="value"
          placeholder="{{'Encontre o que quiser...' | translate}}" aria-label="{{'Encontre o que quiser...' | translate}}" spellcheck="false">
        <div class="form-check">
          <div class="form-check complete">
            <input id="result" name="sortType" type="radio" value="result" checked (click)="setSearchSort('')">
            <label class="p-r-20" for="result">{{'Ordenar por Resultado mais próximo' | translate}}</label>
            <input type="radio" name="sortType" id="dateDesc" value="desc" (click)="setSearchSort('desc')">
            <label class="p-r-20" for="dateDesc">{{'Ordenar por Data Decrescente' | translate}}</label>
            <input id="dateAsc" name="sortType" type="radio" value="asc" (click)="setSearchSort('asc')">
            <label class="p-r-20" for="dateAsc">{{'Ordenar por Data Crescente' | translate}}</label>
          </div>
        </div>
      </div>
      <pg-tabset class="b-t b-grey tab-no-padding" tabAnimation="slide-left" Type="simple" ShowPagination="true"
        (SelectChange)="changePod($event)">
        <pg-tab>
          <ng-template #TabHeading>{{'Resultados' | translate}}</ng-template>
          @if (value != '' || loading) {
            <div>
              @if (loading) {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              }
              <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
                <ng-container cdkColumnDef="title">
                  <td cdk-cell *cdkCellDef="let row">
                    <a href={{redirect(row)}}>
                      <div>
                        <p>
                          <span class="text-complete">
                            <svg-icon [src]="'https://publicfiles.mybeehome.com/icons/default-pods/'+row?.resourceType+'.svg'"
                            [class]="'red'" [applyClass]="true"></svg-icon>
                            {{menu?.getPodName(row?.resourceType)}}
                          </span>
                          @if (row?.resourceType == 'blogpost') {
                            <span class="text-complete">
                              <svg-icon [src]="'https://publicfiles.mybeehome.com/icons/default-pods/blog.svg'"
                              [class]="'red'" [applyClass]="true"></svg-icon>
                              {{menu?.getPodName('blog')}}
                            </span>
                          }
                          @if (row?.resourceType == 'ideasCategory') {
                            <span class="text-complete">
                              <svg-icon [src]="'https://publicfiles.mybeehome.com/icons/default-pods/ideas.svg'"
                              [class]="'red'" [applyClass]="true"></svg-icon>
                              {{'Campanha de ideias' | translate}}
                            </span>
                          }
                          <span class="pull-right overline">{{row?.dateCreate |
                          date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}</span>
                        </p>
                        @if (row?.resourceType != 'directory') {
                          <h6 class="m-b-0">
                            @if (row?.resourceType == 'beezz') {
                              <span class="bold">{{row?.creator?.name |
                                capitalizeName}}:
                              </span>
                            }
                            <app-span-unsafe-html [code]="row?.title"></app-span-unsafe-html>
                          </h6>
                        }
                        @if (row?.resourceType == 'directory') {
                          <h6 class="m-b-0">
                            {{row?.name | capitalizeName}}
                          </h6>
                        }
                      </div>
                    </a>
                  </td>
                </ng-container>
                <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
              </table>
              <mat-paginator
                [length]="searchService?.page?.totalElements || 0"
                [pageSize]="searchService?.page?.size || 20"
                [pageIndex]="searchService?.page?.pageNumber || 0"
                (page)="setPage($event)">
              </mat-paginator>
            </div>
          }
        </pg-tab>
        @if (podSearchableList.beezz && value != '') {
          <pg-tab>
            <ng-template #TabHeading>{{menu?.getPodName('beezz')}}</ng-template>
            @if (value != '' || loading) {
              <div>
                @if (loading) {
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                }
                <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
                  <ng-container cdkColumnDef="title">
                    <td cdk-cell *cdkCellDef="let row">
                      <a href="{{redirect(row)}}">
                        <div class="d-flex  full-height full-width">
                          <div class="full-width">
                            <app-user-display [userObject]="row?.creator" [noLink]="true"></app-user-display>
                            @if (row?.workGroup?.id) {
                              <div class="bg-contrast-lowest b-t b-b b-grey padding-10 m-b-10">
                                {{row?.workGroup?.name}} @if (row?.workGroup?.isArchived) {
                                <span class="label label-warning">{{'Arquivado'| translate}}</span>
                              }
                            </div>
                          }
                          <div class="m-b-20">
                            <app-span-unsafe-html [code]="row?.title"></app-span-unsafe-html>
                          </div>
                          <div class="d-flex align-items-center justify-content-between">
                            <a href="javascript:void(0)">
                              <ul class="reactions pull-left opacity-1">
                                <li>
                                  <a  class="d-flex align-items-center">
                                    @if (row?.likeCount > 0) {
                                      <div class="icon-reaction like">
                                        <img loading=lazy src="assets/reactions/thumbs_up.png" alt="">
                                      </div>
                                    }
                                    @if (row?.celebrateCount > 0) {
                                      <div class="icon-reaction celebrate">
                                        <img loading=lazy src="assets/reactions/clapping_hands.png" alt="">
                                      </div>
                                    }
                                    @if (row?.loveCount > 0) {
                                      <div class="icon-reaction love">
                                        <img loading=lazy src="assets/reactions/sparkling_heart.png" alt="">
                                      </div>
                                    }
                                    @if (row?.laughCount > 0) {
                                      <div class="icon-reaction laugh">
                                        <img loading=lazy src="assets/reactions/laugh.png" alt="">
                                      </div>
                                    }
                                    @if (row?.insightfulCount > 0) {
                                      <div class="icon-reaction insightful">
                                        <img loading=lazy src="assets/reactions/light_bulb_2.png" alt="">
                                      </div>
                                    }
                                    @if (row?.curiousCount > 0) {
                                      <div class="icon-reaction curious">
                                        <img loading=lazy src="assets/reactions/thinking_face.png" alt="">
                                      </div>
                                    }
                                    @if (row?.sadCount > 0) {
                                      <div class="icon-reaction sad">
                                        <img loading=lazy src="assets/reactions/sad.png" alt="">
                                      </div>
                                    }
                                    @if (row?.totalCount > 0) {
                                      <div class="m-l-5 time">{{row?.totalCount}}</div>
                                    }
                                  </a>
                                </li>
                              </ul>
                            </a>
                            
                          </div>
                          <div class="d-flex">
                            @if (row?.comments) {
                              <div class="space-search">
                                <a>
                                  <div class="m-l-5 time overline">{{row?.comments}} @if (row?.comments === 1) {
                                    <span>
                                    {{'comentário'| translate}}</span>
                                    }@if (row?.comments >= 2) {
                                    <span>
                                    {{'comentários'| translate}}</span>
                                  }
                                </div>
                              </a>
                            </div>
                          }
                          <div class="time overline">
                            {{row?.dateCreate | dateAgo}}
                          </div>
                        </div>
                      </div>
                      @if (row?.imageBanner) {
                        <div class="img-conteiner b-l b-grey">
                          <img class="img-max" src="{{row?.imageBanner}}" alt="">
                        </div>
                      }
                    </div>
                  </a>
                </td>
              </ng-container>
              <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
            </table>
            <mat-paginator
              [length]="searchService?.page?.totalElements || 0"
              [pageSize]="searchService?.page?.size || 20"
              [pageIndex]="searchService?.page?.pageNumber || 0"
              (page)="setPage($event)">
            </mat-paginator>
          </div>
        }
      </pg-tab>
    }
    @if (podSearchableList.workGroup && value != '') {
      <pg-tab>
        <ng-template #TabHeading>{{'Posts de grupos' | translate}}</ng-template>
        @if (value != '' || loading) {
          <div>
            @if (loading) {
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
            <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
              <ng-container cdkColumnDef="title">
                <td cdk-cell *cdkCellDef="let row">
                  <a href="{{redirect(row)}}">
                    <div class="d-flex  full-height full-width">
                      <div class="full-width">
                        <app-user-display [userObject]="row?.creator" [noLink]="true"></app-user-display>
                        @if (row?.workGroup?.id) {
                          <div class="bg-contrast-lowest b-t b-b b-grey padding-10 m-b-10">
                            {{row?.workGroup?.name}} @if (row?.workGroup?.isArchived) {
                            <span class="label label-warning">{{'Arquivado'| translate}}</span>
                          }
                        </div>
                      }
                      <div class="m-b-20">
                        <app-span-unsafe-html [code]="row?.title"></app-span-unsafe-html>
                      </div>
                      <div class="d-flex align-items-center justify-content-between">
                        <a href="javascript:void(0)">
                          <ul class="reactions pull-left opacity-1">
                            <li>
                              <a  class="d-flex align-items-center">
                                @if (row?.likeCount > 0) {
                                  <div class="icon-reaction like">
                                    <img loading=lazy src="assets/reactions/thumbs_up.png" alt="">
                                  </div>
                                }
                                @if (row?.celebrateCount > 0) {
                                  <div class="icon-reaction celebrate">
                                    <img loading=lazy src="assets/reactions/clapping_hands.png" alt="">
                                  </div>
                                }
                                @if (row?.loveCount > 0) {
                                  <div class="icon-reaction love">
                                    <img loading=lazy src="assets/reactions/sparkling_heart.png" alt="">
                                  </div>
                                }
                                @if (row?.laughCount > 0) {
                                  <div class="icon-reaction laugh">
                                    <img loading=lazy src="assets/reactions/laugh.png" alt="">
                                  </div>
                                }
                                @if (row?.insightfulCount > 0) {
                                  <div class="icon-reaction insightful">
                                    <img loading=lazy src="assets/reactions/light_bulb_2.png" alt="">
                                  </div>
                                }
                                @if (row?.curiousCount > 0) {
                                  <div class="icon-reaction curious">
                                    <img loading=lazy src="assets/reactions/thinking_face.png" alt="">
                                  </div>
                                }
                                @if (row?.sadCount > 0) {
                                  <div class="icon-reaction sad">
                                    <img loading=lazy src="assets/reactions/sad.png" alt="">
                                  </div>
                                }
                                @if (row?.totalCount > 0) {
                                  <div class="m-l-5 time">{{row?.totalCount}}</div>
                                }
                              </a>
                            </li>
                          </ul>
                        </a>
                        
                      </div>
                      <div class="d-flex">
                        @if (row?.comments) {
                          <div class="space-search">
                            <a>
                              <div class="m-l-5 time overline">{{row?.comments}} @if (row?.comments === 1) {
                                <span>
                                {{'comentário'| translate}}</span>
                                }@if (row?.comments >= 2) {
                                <span>
                                {{'comentários'| translate}}</span>
                              }
                            </div>
                          </a>
                        </div>
                      }
                      <div class="time overline">
                        {{row?.dateCreate | dateAgo}}
                      </div>
                    </div>
                  </div>
                  @if (row?.imageBanner) {
                    <div class="img-conteiner b-l b-grey">
                      <img class="img-max" src="{{row?.imageBanner}}" alt="">
                    </div>
                  }
                </div>
              </a>
            </td>
          </ng-container>
          <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="searchService?.page?.totalElements || 0"
          [pageSize]="searchService?.page?.size || 20"
          [pageIndex]="searchService?.page?.pageNumber || 0"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    }
  </pg-tab>
}
@if (podSearchableList.news && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('news')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href="{{redirect(row)}}">
                <div class="d-flex  full-height full-width">
                  <div class="full-width p-r-20">
                    <p class="m-b-0">
                      <span class="text-danger overline">{{row?.preTitle}}</span>
                      <span class="hint-text  pull-right overline">
                        {{row?.dateCreate |
                        date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}
                      </span>
                    </p>
                    <div class="d-flex align-items-center justify-content-between">
                      <a href="javascript:void(0)">
                        <ul class="reactions pull-left opacity-1">
                          <li>
                            <a  class="d-flex align-items-center">
                              @if (row?.likeCount > 0) {
                                <div class="icon-reaction like">
                                  <img loading=lazy src="assets/reactions/thumbs_up.png" alt="">
                                </div>
                              }
                              @if (row?.celebrateCount > 0) {
                                <div class="icon-reaction celebrate">
                                  <img loading=lazy src="assets/reactions/clapping_hands.png" alt="">
                                </div>
                              }
                              @if (row?.loveCount > 0) {
                                <div class="icon-reaction love">
                                  <img loading=lazy src="assets/reactions/sparkling_heart.png" alt="">
                                </div>
                              }
                              @if (row?.laughCount > 0) {
                                <div class="icon-reaction laugh">
                                  <img loading=lazy src="assets/reactions/laugh.png" alt="">
                                </div>
                              }
                              @if (row?.insightfulCount > 0) {
                                <div class="icon-reaction insightful">
                                  <img loading=lazy src="assets/reactions/light_bulb_2.png" alt="">
                                </div>
                              }
                              @if (row?.curiousCount > 0) {
                                <div class="icon-reaction curious">
                                  <img loading=lazy src="assets/reactions/thinking_face.png" alt="">
                                </div>
                              }
                              @if (row?.sadCount > 0) {
                                <div class="icon-reaction sad">
                                  <img loading=lazy src="assets/reactions/sad.png" alt="">
                                </div>
                              }
                              @if (row?.totalCount > 0) {
                                <div class="m-l-5 time">{{row?.totalCount}}</div>
                              }
                            </a>
                          </li>
                        </ul>
                      </a>
                    </div>
                    <div class="d-flex">
                      @if (row?.comments) {
                        <div class="space-search">
                          <a>
                            <div class="m-l-5 time overline">{{row?.comments}} @if (row?.comments === 1) {
                              <span>
                              {{'comentário'| translate}}</span>
                              }@if (row?.comments >= 2) {
                              <span>
                              {{'comentários'| translate}}</span>
                            }
                          </div>
                        </a>
                      </div>
                    }
                  </div>
                  <h6>{{row?.title}}</h6>
                </div>
                <div class="img-conteiner b-l b-grey">
                  <img class="img-max-60" src="{{row?.imageBanner}}" alt="">
                </div>
              </div>
            </a>
          </td>
        </ng-container>
        <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
      </table>
      <mat-paginator
        [length]="searchService?.page?.totalElements || 0"
        [pageSize]="searchService?.page?.size || 20"
        [pageIndex]="searchService?.page?.pageNumber || 0"
        (page)="setPage($event)">
      </mat-paginator>
    </div>
  }
</pg-tab>
}
@if (podSearchableList.events && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('events')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <p class="hint-text overline">{{row?.dateCreate |
                date:'longDate':util?.userTimeZone:util.translate.getCurrentLang()}}</p>
                <p>{{row?.title}}</p>
              </a>
            </td>
          </ng-container>
          <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="searchService?.page?.totalElements || 0"
          [pageSize]="searchService?.page?.size || 20"
          [pageIndex]="searchService?.page?.pageNumber || 0"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    }
  </pg-tab>
}
@if (podSearchableList.video && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('video')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <div class="d-flex  full-height full-width">
                  <div class="full-width p-r-20">
                    <p class="m-b-0">
                      <span class="text-danger overline">{{row?.preTitle}}</span>
                      <span class="hint-text  pull-right overline">
                        {{row?.dateCreate |
                        date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}
                      </span>
                    </p>
                    <div class="d-flex align-items-center justify-content-between">
                      <a href="javascript:void(0)">
                        <ul class="reactions pull-left opacity-1">
                          <li>
                            <a  class="d-flex align-items-center">
                              @if (row?.likeCount > 0) {
                                <div class="icon-reaction like">
                                  <img loading=lazy src="assets/reactions/thumbs_up.png" alt="">
                                </div>
                              }
                              @if (row?.celebrateCount > 0) {
                                <div class="icon-reaction celebrate">
                                  <img loading=lazy src="assets/reactions/clapping_hands.png" alt="">
                                </div>
                              }
                              @if (row?.loveCount > 0) {
                                <div class="icon-reaction love">
                                  <img loading=lazy src="assets/reactions/sparkling_heart.png" alt="">
                                </div>
                              }
                              @if (row?.laughCount > 0) {
                                <div class="icon-reaction laugh">
                                  <img loading=lazy src="assets/reactions/laugh.png" alt="">
                                </div>
                              }
                              @if (row?.insightfulCount > 0) {
                                <div class="icon-reaction insightful">
                                  <img loading=lazy src="assets/reactions/light_bulb_2.png" alt="">
                                </div>
                              }
                              @if (row?.curiousCount > 0) {
                                <div class="icon-reaction curious">
                                  <img loading=lazy src="assets/reactions/thinking_face.png" alt="">
                                </div>
                              }
                              @if (row?.sadCount > 0) {
                                <div class="icon-reaction sad">
                                  <img loading=lazy src="assets/reactions/sad.png" alt="">
                                </div>
                              }
                              @if (row?.totalCount > 0) {
                                <div class="m-l-5 time">{{row?.totalCount}}</div>
                              }
                            </a>
                          </li>
                        </ul>
                      </a>
                    </div>
                    <div class="d-flex">
                      @if (row?.comments) {
                        <div class="space-search">
                          <a>
                            <div class="m-l-5 time overline">{{row?.comments}} @if (row?.comments === 1) {
                              <span>
                              {{'comentário'| translate}}</span>
                              }@if (row?.comments >= 2) {
                              <span>
                              {{'comentários'| translate}}</span>
                            }
                          </div>
                        </a>
                      </div>
                    }
                  </div>
                  <h6>{{row?.title}}</h6>
                </div>
                <div class="img-conteiner b-l b-grey">
                  <img class="img-max-60" src="{{row?.imageBanner}}" alt="">
                </div>
              </div>
            </a>
          </td>
        </ng-container>
        <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
      </table>
      <mat-paginator
        [length]="searchService?.page?.totalElements || 0"
        [pageSize]="searchService?.page?.size || 20"
        [pageIndex]="searchService?.page?.pageNumber || 0"
        (page)="setPage($event)">
      </mat-paginator>
    </div>
  }
</pg-tab>
}
@if (podSearchableList.poll && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('poll')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <div class="full-width p-r-20">
                  <p class="m-b-0">
                    <span class="text-danger overline">{{row?.preTitle}}</span>
                    <span class="hint-text  pull-right overline">
                      {{row?.dateCreate |
                      date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}
                    </span>
                  </p>
                  <div class="d-flex align-items-center justify-content-between">
                    <a href="javascript:void(0)">
                      <ul class="reactions pull-left opacity-1">
                        <li>
                          <a  class="d-flex align-items-center">
                            @if (row?.likeCount > 0) {
                              <div class="icon-reaction like">
                                <img loading=lazy src="assets/reactions/thumbs_up.png" alt="">
                              </div>
                            }
                            @if (row?.celebrateCount > 0) {
                              <div class="icon-reaction celebrate">
                                <img loading=lazy src="assets/reactions/clapping_hands.png" alt="">
                              </div>
                            }
                            @if (row?.loveCount > 0) {
                              <div class="icon-reaction love">
                                <img loading=lazy src="assets/reactions/sparkling_heart.png" alt="">
                              </div>
                            }
                            @if (row?.laughCount > 0) {
                              <div class="icon-reaction laugh">
                                <img loading=lazy src="assets/reactions/laugh.png" alt="">
                              </div>
                            }
                            @if (row?.insightfulCount > 0) {
                              <div class="icon-reaction insightful">
                                <img loading=lazy src="assets/reactions/light_bulb_2.png" alt="">
                              </div>
                            }
                            @if (row?.curiousCount > 0) {
                              <div class="icon-reaction curious">
                                <img loading=lazy src="assets/reactions/thinking_face.png" alt="">
                              </div>
                            }
                            @if (row?.sadCount > 0) {
                              <div class="icon-reaction sad">
                                <img loading=lazy src="assets/reactions/sad.png" alt="">
                              </div>
                            }
                            @if (row?.totalCount > 0) {
                              <div class="m-l-5 time">{{row?.totalCount}}</div>
                            }
                          </a>
                        </li>
                      </ul>
                    </a>
                  </div>
                  <div class="d-flex">
                    @if (row?.comments) {
                      <div class="space-search">
                        <a>
                          <div class="m-l-5 time overline">{{row?.comments}} @if (row?.comments === 1) {
                            <span>
                            {{'comentário'| translate}}</span>
                            }@if (row?.comments >= 2) {
                            <span>
                            {{'comentários'| translate}}</span>
                          }
                        </div>
                      </a>
                    </div>
                  }
                </div>
                <h6>{{row?.title}}</h6>
              </div>
            </a>
          </td>
        </ng-container>
        <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
      </table>
      <mat-paginator
        [length]="searchService?.page?.totalElements || 0"
        [pageSize]="searchService?.page?.size || 20"
        [pageIndex]="searchService?.page?.pageNumber || 0"
        (page)="setPage($event)">
      </mat-paginator>
    </div>
  }
</pg-tab>
}
@if (podSearchableList.cms && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('cms')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <div class="d-flex  full-height full-width">
                  <div class="doc-conteiner b-l b-grey">
                    <img class="doc-icon" src="{{row?.imageBanner}}" alt="">
                  </div>
                  <div class="full-width p-r-20">
                    <p class="m-b-0">
                      <span class="text-danger overline">{{row?.preTitle}}</span>
                      <span class="hint-text  pull-right overline">
                        {{row?.dateCreate |
                        date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}
                      </span>
                    </p>
                    <h6>{{row?.title}}</h6>
                  </div>
                </div>
              </a>
            </td>
          </ng-container>
          <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="searchService?.page?.totalElements || 0"
          [pageSize]="searchService?.page?.size || 20"
          [pageIndex]="searchService?.page?.pageNumber || 0"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    }
  </pg-tab>
}
@if (podSearchableList.wiki && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('wiki')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <h6 class="inline">{{row?.title}}</h6>
                <span class="hint-text  pull-right overline">
                  {{row?.dateCreate |
                  date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}
                </span>
              </a>
            </td>
          </ng-container>
          <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="searchService?.page?.totalElements || 0"
          [pageSize]="searchService?.page?.size || 20"
          [pageIndex]="searchService?.page?.pageNumber || 0"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    }
  </pg-tab>
}
@if (podSearchableList.blog && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('blog')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <div class="d-flex  full-height full-width">
                  <div class="full-width p-r-20">
                    <p class="m-b-0">
                      <span class="text-danger overline">{{row?.preTitle}}</span>
                      <span class="hint-text  pull-right overline">
                        {{row?.dateCreate |
                        date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}
                      </span>
                    </p>
                    <div class="d-flex align-items-center justify-content-between">
                      <a href="javascript:void(0)">
                        <ul class="reactions pull-left opacity-1">
                          <li>
                            <a  class="d-flex align-items-center">
                              @if (row?.likeCount > 0) {
                                <div class="icon-reaction like">
                                  <img loading=lazy src="assets/reactions/thumbs_up.png" alt="">
                                </div>
                              }
                              @if (row?.celebrateCount > 0) {
                                <div class="icon-reaction celebrate">
                                  <img loading=lazy src="assets/reactions/clapping_hands.png" alt="">
                                </div>
                              }
                              @if (row?.loveCount > 0) {
                                <div class="icon-reaction love">
                                  <img loading=lazy src="assets/reactions/sparkling_heart.png" alt="">
                                </div>
                              }
                              @if (row?.laughCount > 0) {
                                <div class="icon-reaction laugh">
                                  <img loading=lazy src="assets/reactions/laugh.png" alt="">
                                </div>
                              }
                              @if (row?.insightfulCount > 0) {
                                <div class="icon-reaction insightful">
                                  <img loading=lazy src="assets/reactions/light_bulb_2.png" alt="">
                                </div>
                              }
                              @if (row?.curiousCount > 0) {
                                <div class="icon-reaction curious">
                                  <img loading=lazy src="assets/reactions/thinking_face.png" alt="">
                                </div>
                              }
                              @if (row?.sadCount > 0) {
                                <div class="icon-reaction sad">
                                  <img loading=lazy src="assets/reactions/sad.png" alt="">
                                </div>
                              }
                              @if (row?.totalCount > 0) {
                                <div class="m-l-5 time">{{row?.totalCount}}</div>
                              }
                            </a>
                          </li>
                        </ul>
                      </a>
                    </div>
                    <div class="d-flex">
                      @if (row?.comments) {
                        <div class="space-search">
                          <a>
                            <div class="m-l-5 time overline">{{row?.comments}} @if (row?.comments === 1) {
                              <span>
                              {{'comentário'| translate}}</span>
                              }@if (row?.comments >= 2) {
                              <span>
                              {{'comentários'| translate}}</span>
                            }
                          </div>
                        </a>
                      </div>
                    }
                  </div>
                  <h6>{{row?.title}}</h6>
                </div>
                <div class="img-conteiner b-l b-grey">
                  <img class="img-max-60" src="{{row?.imageBanner}}" alt="">
                </div>
              </div>
            </a>
          </td>
        </ng-container>
        <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
      </table>
      <mat-paginator
        [length]="searchService?.page?.totalElements || 0"
        [pageSize]="searchService?.page?.size || 20"
        [pageIndex]="searchService?.page?.pageNumber || 0"
        (page)="setPage($event)">
      </mat-paginator>
    </div>
  }
</pg-tab>
}
@if (podSearchableList.podcast && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('podcast')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <h6 class="inline">{{row?.title}}</h6>
                <span class="hint-text  pull-right overline">
                  {{row?.dateCreate |
                  date:'short':util?.userTimeZone:util.translate.getCurrentLang()}}
                </span>
                <div class="d-flex align-items-center justify-content-between">
                  <a href="javascript:void(0)">
                    <ul class="reactions pull-left opacity-1">
                      <li>
                        <a  class="d-flex align-items-center">
                          @if (row?.likeCount > 0) {
                            <div class="icon-reaction like">
                              <img loading=lazy src="assets/reactions/thumbs_up.png" alt="">
                            </div>
                          }
                          @if (row?.celebrateCount > 0) {
                            <div class="icon-reaction celebrate">
                              <img loading=lazy src="assets/reactions/clapping_hands.png" alt="">
                            </div>
                          }
                          @if (row?.loveCount > 0) {
                            <div class="icon-reaction love">
                              <img loading=lazy src="assets/reactions/sparkling_heart.png" alt="">
                            </div>
                          }
                          @if (row?.laughCount > 0) {
                            <div class="icon-reaction laugh">
                              <img loading=lazy src="assets/reactions/laugh.png" alt="">
                            </div>
                          }
                          @if (row?.insightfulCount > 0) {
                            <div class="icon-reaction insightful">
                              <img loading=lazy src="assets/reactions/light_bulb_2.png" alt="">
                            </div>
                          }
                          @if (row?.curiousCount > 0) {
                            <div class="icon-reaction curious">
                              <img loading=lazy src="assets/reactions/thinking_face.png" alt="">
                            </div>
                          }
                          @if (row?.sadCount > 0) {
                            <div class="icon-reaction sad">
                              <img loading=lazy src="assets/reactions/sad.png" alt="">
                            </div>
                          }
                          @if (row?.totalCount > 0) {
                            <div class="m-l-5 time">{{row?.totalCount}}</div>
                          }
                        </a>
                      </li>
                    </ul>
                  </a>
                </div>
                <div class="d-flex">
                  @if (row?.comments) {
                    <div class="space-search">
                      <a>
                        <div class="m-l-5 time overline">{{row?.comments}} @if (row?.comments === 1) {
                          <span>
                          {{'comentário'| translate}}</span>
                          }@if (row?.comments >= 2) {
                          <span>
                          {{'comentários'| translate}}</span>
                        }
                      </div>
                    </a>
                  </div>
                }
              </div>
            </a>
          </td>
        </ng-container>
        <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
      </table>
      <mat-paginator
        [length]="searchService?.page?.totalElements || 0"
        [pageSize]="searchService?.page?.size || 20"
        [pageIndex]="searchService?.page?.pageNumber || 0"
        (page)="setPage($event)">
      </mat-paginator>
    </div>
  }
</pg-tab>
}
@if (podSearchableList.directory && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('directory')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <app-user-display (click)="isVisible = false;"
                [userObject]="{id: row.id, name: row.name, jobtitle: row.description, company: row.title, companyDepartment: row.preTitle, photoS3aws: row?.imageBanner}">
              </app-user-display>
            </td>
          </ng-container>
          <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="searchService?.page?.totalElements || 0"
          [pageSize]="searchService?.page?.size || 20"
          [pageIndex]="searchService?.page?.pageNumber || 0"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    }
  </pg-tab>
}
@if (podSearchableList.training && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('training')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <div class="d-flex  full-height full-width">
                  <div class="full-width p-r-20">
                    <p class="m-b-0">
                      <span class="text-danger overline">{{row?.preTitle}}</span>
                    </p>
                    <h6>{{row?.title}}</h6>
                  </div>
                  <div class="img-conteiner b-l b-grey">
                    <img class="img-max-60" src="{{row?.coverName}}" alt="">
                  </div>
                </div>
              </a>
            </td>
          </ng-container>
          <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="searchService?.page?.totalElements || 0"
          [pageSize]="searchService?.page?.size || 20"
          [pageIndex]="searchService?.page?.pageNumber || 0"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    }
  </pg-tab>
}
@if (podSearchableList.ideas && value != '') {
  <pg-tab>
    <ng-template #TabHeading>{{menu?.getPodName('ideas')}}</ng-template>
    @if (value != '' || loading) {
      <div>
        @if (loading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <table cdk-table [dataSource]="rows" class="table table-condensed table-hover">
          <ng-container cdkColumnDef="title">
            <td cdk-cell *cdkCellDef="let row">
              <a href={{redirect(row)}}>
                <div class="d-flex  full-height full-width">
                  <div class="full-width p-r-20">
                    <p class="m-b-0">
                      <span class="text-danger overline">{{row?.resourceType == 'ideas' ? ('Ideia' |translate) : 'Campanha' | translate}}</span>
                    </p>
                    <h6>{{row?.title}}</h6>
                  </div>
                </div>
              </a>
            </td>
          </ng-container>
          <tr cdk-row *cdkRowDef="let row; columns: searchDisplayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="searchService?.page?.totalElements || 0"
          [pageSize]="searchService?.page?.size || 20"
          [pageIndex]="searchService?.page?.pageNumber || 0"
          (page)="setPage($event)">
        </mat-paginator>
      </div>
    }
  </pg-tab>
}
</pg-tabset>
</div>
</div>
}

<app-confirm-modal #confirmModal (confirmEvent)="exportResults()" [text]="modalMessage" [type]="'confirm'"
[errorMessage]="'Não foi possível exportar o relatório. Por favor, tente novamente.'"></app-confirm-modal>
